import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import CustomPopupModel from '../custom-popup/Custom-Popup';
import { LOGOUT } from '../../constants/CommonConst';

const SessionExpiredModal = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const onSignInAgain = useCallback(async () => {
    setOpen(false);
    try {
      const ssoLogoutUrl = localStorage.getItem(LOGOUT);
      if (ssoLogoutUrl) {
        localStorage.removeItem(LOGOUT);

        const msFrame = document.createElement('iframe');
        msFrame.style.display = 'none';
        msFrame.src = 'https://login.microsoftonline.com/common/wsfederation?wa=wsignout1.0';
        document.body.appendChild(msFrame);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        try { msFrame.remove(); } catch (e) {}

        const logoutPopup = window.open(ssoLogoutUrl, 'sso_logout', 'width=500,height=600');
        if (logoutPopup) {
          await new Promise((resolve) => {
            const pollTimer = setInterval(() => {
              try {
                if (logoutPopup.closed) {
                  clearInterval(pollTimer);
                  resolve();
                  return;
                }
                if (logoutPopup.location?.origin === window.location.origin) {
                  clearInterval(pollTimer);
                  logoutPopup.close();
                  resolve();
                }
              } catch (e) {}
            }, 500);
            setTimeout(() => {
              clearInterval(pollTimer);
              try { if (!logoutPopup.closed) logoutPopup.close(); } catch (e) {}
              resolve();
            }, 10000);
          });
        }
      }
    } catch (e) {}
    sessionStorage.setItem('logout_success', 'true');
    try {
      history.push('/prelogin');
    } catch (e) {
      window.location.href = '/prelogin';
    }
  }, [history]);

  const onClose = useCallback(() => {
    // no-op to keep modal open until user confirms
  }, []);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('session-expired', handler);
    return () => window.removeEventListener('session-expired', handler);
  }, []);

  const popUp = useMemo(
    () => ({
      status: open,
      title: 'Your session has expired',
      description: 'You have been signed out of the console.',
      buttonName: 'Sign in again'
    }),
    [open]
  );

  return (
    <CustomPopupModel
      popUp={popUp}
      onClick={onSignInAgain}
      onClickSwap={() => {}}
      onClickCancel={onClose}
      NoCancelButtonNeeded={true}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    />
  );
};

export default SessionExpiredModal;
